var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileTypeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9325 2.66908C4.21381 2.38777 4.59534 2.22974 4.99316 2.22974H13.9932C14.1921 2.22974 14.3828 2.30875 14.5235 2.44941L19.7735 7.69941C19.9141 7.84006 19.9932 8.03082 19.9932 8.22974V20.2297C19.9932 20.6276 19.8351 21.0091 19.5538 21.2904C19.2725 21.5717 18.891 21.7297 18.4932 21.7297H4.99316C4.59534 21.7297 4.21381 21.5717 3.9325 21.2904C3.6512 21.0091 3.49316 20.6276 3.49316 20.2297V3.72974C3.49316 3.33191 3.6512 2.95038 3.9325 2.66908ZM13.6825 3.72974L4.99316 3.72974L4.99316 20.2297H18.4932V8.5404L13.6825 3.72974Z",
    fill: "#1B1C1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9932 2.22974C14.4074 2.22974 14.7432 2.56552 14.7432 2.97974V7.47974H19.2432C19.6574 7.47974 19.9932 7.81552 19.9932 8.22974C19.9932 8.64395 19.6574 8.97974 19.2432 8.97974H13.9932C13.579 8.97974 13.2432 8.64395 13.2432 8.22974V2.97974C13.2432 2.56552 13.579 2.22974 13.9932 2.22974Z",
    fill: "#1B1C1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99316 12.7297C7.99316 12.3155 8.32895 11.9797 8.74316 11.9797H14.7432C15.1574 11.9797 15.4932 12.3155 15.4932 12.7297C15.4932 13.1439 15.1574 13.4797 14.7432 13.4797H8.74316C8.32895 13.4797 7.99316 13.1439 7.99316 12.7297Z",
    fill: "#1B1C1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99316 15.7297C7.99316 15.3155 8.32895 14.9797 8.74316 14.9797H14.7432C15.1574 14.9797 15.4932 15.3155 15.4932 15.7297C15.4932 16.1439 15.1574 16.4797 14.7432 16.4797H8.74316C8.32895 16.4797 7.99316 16.1439 7.99316 15.7297Z",
    fill: "#1B1C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTypeIcon);
export default __webpack_public_path__ + "static/media/file-type-icon.21a0eb17f012d913bb1f8c89bafa489c.svg";
export { ForwardRef as ReactComponent };